import { Injectable } from '@angular/core';
import { LocalNotifications } from '@capacitor/local-notifications';
//import { random } from 'lodash';
import { Appointement } from '../../providers/content-provider/data-objects';
import { AppSettings } from '../../app/appSettings';
//import * as moment from "moment/moment";
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  DEBUG = AppSettings.DEBUG;
  dayInMillis: number = 24 * 60 * 60 * 1000;
  hInMillis: number = 60 * 60 * 1000;

  constructor() {

  }

  scheduleNotification(id: string, title: string, text: string, start: Date) {
    if(this.DEBUG){
      console.log('scheduled', start);
    }
    LocalNotifications.schedule({
      notifications: [
        {
          title: title,
          body: text,
          id: parseInt(id),
          schedule: {
            at: start,
          },

        },
      ],
    });


  }

/*   showLocalNotification(title: string, body: string, at: Date, id: number = random(0, 1000)): void {
    LocalNotifications.schedule({
      notifications: [
        {
          title,
          body,
          id,
          schedule: {
            at,
          },
        },
      ],
    });
  } */






  scheduleApp(app: Appointement) {
    const now: Date = new Date();
    const start: Date = new Date(app.start);
    const nowtime = now.getTime();
    const starttime = start.getTime();
    let notiTime: Date;
    let notiText = 'Sie haben am ' +  moment(app.start).format('dddd DD.MM.YYYY, HH:mm');


    if ((starttime - nowtime) >= this.dayInMillis) {
      notiTime = new Date(starttime - this.dayInMillis);
      //notiText += 'morgen um ' + start.getHours() + ':' + (start.getMinutes() < 10 ? '0' + start.getMinutes() : start.getMinutes());
    } else {
      notiTime = new Date(starttime - this.hInMillis * 2);
      //notiText += 'heute um ' + start.getHours() + ':' + (start.getMinutes() < 10 ? '0' + start.getMinutes() : start.getMinutes());
    }
    notiText += ' Uhr einen Termin.';
    if(this.DEBUG)console.log('scheduled App', app.id, 'Termed Terminerinnerung', notiText, notiTime);
    this.scheduleNotification(app.id, 'Termed Terminerinnerung', notiText, notiTime);
  }

  clearNotification(id: string) {
    // tslint:disable-next-line:radix
   // LocalNotifications.cancel();
   LocalNotifications.cancel({
    notifications: [
      {
        id: parseInt(id),
      },
    ],
  })
  }

  clearAllNotification() {
    LocalNotifications.removeAllListeners().then((response) => {
      if(this.DEBUG)console.log('clearAllNotifications', response);
    }
  );
   // LocalNotifications.cancelAll();
  }

  setupNotifications(apps: Appointement[]) {
   // this.localNotifications.cancelAll();
    if(this.DEBUG)console.log('setupNotifications', apps);
    LocalNotifications.removeAllListeners();
    for (let i = 0; i < apps.length; ++i) {
      this.scheduleApp(apps[i]);
    }
  }











}

/* import { LocalNotifications } from '@ionic-native/local-notifications';
import { Injectable } from '@angular/core';
import { Appointement } from '../../providers/content-provider/data-objects';
import { AppSettings } from '../../app/appSettings';


@Injectable()
export class NotificationService {
  DEBUG = AppSettings.DEBUG;
  dayInMillis: number = 24 * 60 * 60 * 1000;
  hInMillis: number = 60 * 60 * 1000;

  constructor(private localNotifications: LocalNotifications) {
  }

  scheduleNotification(id: string, title: string, text: string, start: Date) {
    if(this.DEBUG){
      console.log('scheduled');
    }
    this.localNotifications.schedule({
      // tslint:disable-next-line:radix
      id: parseInt(id),
      title: title,
      text: text,
      trigger: {at: start},
      icon: 'res://icon_symbol_only',
      smallIcon: 'res://icon_symbol_only',
      color: '#95c11f'
    });

  }



  scheduleApp(app: Appointement) {
    const now: Date = new Date();
    const start: Date = app.start;
    let notiTime: Date;
    let notiText = 'Sie haben ';
    if (start.getTime() - now.getTime() >= this.dayInMillis) {
      notiTime = new Date(start.getTime() - this.dayInMillis);
      notiText += 'morgen um ' + start.getHours() + ':' + (start.getMinutes() < 10 ? '0' + start.getMinutes() : start.getMinutes());
    } else {
      notiTime = new Date(start.getTime() - this.hInMillis * 2);
      notiText += 'heute um ' + start.getHours() + ':' + (start.getMinutes() < 10 ? '0' + start.getMinutes() : start.getMinutes());
    }
    notiText += ' einen Termin.';
    this.scheduleNotification(app.id, 'Termed Terminerinnerung', notiText, notiTime);
  }

  clearNotification(id: string) {
    // tslint:disable-next-line:radix
    this.localNotifications.cancel(parseInt(id));
  }

  clearAllNotification() {
    this.localNotifications.cancelAll();
  }

  setupNotifications(apps: Appointement[]) {
    this.localNotifications.cancelAll();
    for (let i = 0; i < apps.length; ++i) {
      this.scheduleApp(apps[i]);
    }
  }

} */
